module.exports = __webpack_public_path__ + "static/media/ecosentino.ffd2f90d.svg";